module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-grey.4b4fb8fa.svg";